var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 67,
    viewBox: "0 0 66 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 55.0928L36.5555 57.0373L38.5 58.9819L40.4445 57.0373L38.5 55.0928ZM16.5 8.34277C14.9812 8.34277 13.75 9.57399 13.75 11.0928C13.75 12.6116 14.9812 13.8428 16.5 13.8428L16.5 8.34277ZM22.8055 43.2873L36.5555 57.0373L40.4445 53.1482L26.6945 39.3982L22.8055 43.2873ZM40.4445 57.0373L54.1945 43.2873L50.3055 39.3982L36.5555 53.1482L40.4445 57.0373ZM41.25 55.0928L41.25 27.5928L35.75 27.5928L35.75 55.0928L41.25 55.0928ZM22 8.34277L16.5 8.34277L16.5 13.8428L22 13.8428L22 8.34277ZM41.25 27.5928C41.25 16.9613 32.6315 8.34277 22 8.34277L22 13.8428C29.5939 13.8428 35.75 19.9989 35.75 27.5928L41.25 27.5928Z",
    fill: "#FF2241"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.2f15ec4854125932f0d2d4a7350238d1.svg";
export { ForwardRef as ReactComponent };